<template>
  <div class="order-detail-address">
    <div class="order-detail-address-info">
      <ym-icon class="order-detail-address-positioning" name="positioning" />
      <span v-if="recipient !== ''"
            class="order-detail-address-recipient"
      >
        {{ recipient }}
      </span>
      <span v-if="mobile !== ''"
            class="order-detail-address-mobile"
      >
        {{ formatMobile(mobile) }}
      </span>
    </div>
    <div v-if="region !== ''"
         class="order-detail-address-region"
    >
      {{ region }}
    </div>
    <div v-if="detail !== ''"
         class="order-detail-address-detail"
    >
      {{ detail }}
    </div>
  </div>
</template>

<script>
  import { formatMobile } from '@/utils';

  export default {
    name: 'OrderDetailAddress',
    props: {
      recipient: {
        type: String,
        default: '',
      },
      mobile: {
        type: String,
        default: '',
      },
      region: {
        type: String,
        default: '',
      },
      detail: {
        type: String,
        default: '',
      },
    },
    methods: {
      formatMobile,
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .order-detail-address {
    color: @color-text-base;
    font-weight: @font-weight-strong;
    line-height: 1;

    &-positioning {
      font-size: 36px;
      margin-right: @size-small;
    }

    &-recipient {
      margin-right: @size-small;
    }

    &-info {
      margin: 0 0 @size-base;
    }

    &-region {
      margin-bottom: @size-base;
      font-weight: @font-weight-primary;
      line-height: 1;
    }

    &-detail {
      font-size: @font-size-medium;
      line-height: 1.4;
    }
  }

</style>
